<template>
    <div>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h5 class="text-h4">{{ item_name }} {{ from }} - {{ to }}</h5>
                    <p class="subtitle-1"> Breakdown of production of {{ item_name }}</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-sheet>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th>Invoice Code</th>
                                    <th>Invoice Date</th>
                                    <th>Customer</th>
                                    <th>Quantity</th>
                                    <th>Price</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(d,i) in data" :key="i">
                                    <td><router-link :to="{ name: 'CustomerInvoiceDisplay', params: { id: d.invoice_id } }">{{ d.invoice_code }}</router-link></td>
                                    <td>{{ d.invoice_date }}</td>
                                    <td>{{ d.customer_code }} - {{ d.customer_name }}</td>
                                    <td>{{ formatNumber(d.quantity) }}</td>
                                    <td>{{ formatNumber(d.price) }}</td>
                                    <td>{{ formatNumber(d.total) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="3">Total</td>
                                    <td>{{ formatNumber(getTotal(data, "quantity")) }}</td>
                                    <td></td>
                                    <td>{{ formatNumber(getTotal(data, "total")) }}</td>
                                </tr>
                            </tfoot>
                        </v-simple-table>
                    </v-sheet>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { getInvoiceItemBreakdown } from "../../services/sales/reporting";
import { getTotal } from './../../utils/accounting';
import { formatNumber } from 'accounting';
export default {
    name: "InvoiceItemBreakdownView",
    data() {
        return {
            item_name: "",
            item_id: null,
            from: null,
            to: null,
            loading: true,
            data: []
        }
    },
    methods: {
        getTotal,
        formatNumber(n) {
            return formatNumber(n, 2);
        },
        getData() {
            getInvoiceItemBreakdown({item_id: this.item_id, from: this.from, to: this.to})
                .then((res) => {
                    this.loading = true
                    this.data = res.data
                })
                .finally(() => {
                    this.loading = false
                })
        }        
    },
    mounted () {
        this.item_id = this.$route.query["item_id"]
        this.item_name = decodeURI(this.$route.query["item_name"])
        this.from = this.$route.query["from"]
        this.to = this.$route.query["to"]
        this.getData()
    }
}
</script>